module.exports = __webpack_public_path__ + "static/media/exhibition-map.7c97a964.png";